// extracted by mini-css-extract-plugin
export default {"product-container":"Product_product-container__Pmi4d","product":"Product_product__q71Tp","image":"Product_image__yVrxf","title":"Product_title__S3+EJ"};